import {Injectable} from "@angular/core";
import {Subject} from "rxjs/Subject";
import {FamilyAlbum} from "../../model/family-album";
import {UrlService} from "../url.service";

@Injectable()
export class CurrentEventService {
    // Observable string sources
    private eventChangedSource = new Subject<FamilyAlbum>();
    currentEvent:FamilyAlbum;

    // Observable string streams
    eventChange$ = this.eventChangedSource.asObservable();

    constructor(private urlService:UrlService) {

    }

    // Service message commands
    changeEvent(event:FamilyAlbum) {
        if (event!=null && event.pictures != null && event.pictures.length > 0) {
            event.bannerUrl = this.urlService.getPictureMiniatureUrl(event.id, event.pictures[0].id);
            event.bannerHDUrl = this.urlService.getPictureUrl(event.id, event.pictures[0].id);
        }

        this.currentEvent = event;

        if (event != null) {
            this.eventChangedSource.next(event);
        } else {
            this.eventChangedSource.next(null);
        }
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/communication/currentEventService.ts